var _path, _g, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPsd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "-4 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.112.051c-2.802 0-5.073 2.273-5.073 5.075v53.841c0 2.802 2.271 5.073 5.073 5.073h45.775c2.801 0 5.074-2.271 5.074-5.073v-38.606l-18.903-20.31h-31.946z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#0C77C6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.977 20.352v1h-12.799s-6.312-1.26-6.129-6.707c0 0 .208 5.707 6.004 5.707h12.924z",
    fill: "#0959B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.074 0v14.561c0 1.656 1.104 5.791 6.104 5.791h12.799l-18.903-20.352z",
    opacity: 0.5,
    fill: "#ffffff"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.952 49.011h-3.331v4.141c0 .414-.324.738-.756.738-.414 0-.738-.324-.738-.738v-10.298c0-.594.486-1.081 1.08-1.081h3.745c2.413 0 3.763 1.657 3.763 3.619 0 1.963-1.387 3.619-3.763 3.619zm-.181-5.906h-3.15v4.573h3.15c1.423 0 2.395-.936 2.395-2.287 0-1.349-.972-2.286-2.395-2.286zm10.26 10.894c-1.781 0-3.187-.594-4.213-1.495-.162-.144-.234-.342-.234-.54 0-.36.271-.756.703-.756.144 0 .306.036.432.144.828.739 1.98 1.314 3.367 1.314 2.143 0 2.826-1.152 2.826-2.071 0-3.097-7.111-1.386-7.111-5.672 0-1.98 1.764-3.331 4.123-3.331 1.549 0 2.881.467 3.854 1.278.162.144.252.342.252.54 0 .36-.307.72-.703.72-.144 0-.305-.054-.432-.162-.883-.72-1.98-1.044-3.078-1.044-1.441 0-2.467.774-2.467 1.909 0 2.701 7.111 1.152 7.111 5.636 0 1.748-1.188 3.53-4.43 3.53zm11.215-.216h-3.025c-.594 0-1.08-.487-1.08-1.081v-9.849c0-.594.486-1.081 1.08-1.081h3.025c3.727 0 6.157 2.611 6.157 6.014 0 3.422-2.43 5.997-6.157 5.997zm0-10.678h-2.611v9.345h2.611c2.916 0 4.609-2.088 4.609-4.663 0-2.593-1.638-4.682-4.609-4.682z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPsd);
export default __webpack_public_path__ + "static/media/psd.6a2716f1acec328bed7b32f8b24c6edf.svg";
export { ForwardRef as ReactComponent };